import { jsx as r } from "@emotion/react/jsx-runtime";
import { BusinessModalProvider as a } from "./BusinessModalContext.js";
import { BusinessModalComponent as c } from "./subComponents/BusinessModalComponent/BusinessModalComponent.js";
const x = ({
  open: o,
  setOpen: e,
  persistentFilterKeysOnReset: t = [],
  filters: s = {},
  setFilters: i,
  readOnlyFilters: u = {},
  apiBaseUrl: n = "",
  variant: m = "all",
  translations: d,
  filterVisibility: l = {
    query: !0,
    city: !0,
    org_id: !0
  },
  hasBusinessLimit: p = !0
}) => /* @__PURE__ */ r(a, { open: o, setOpen: e, persistentFilterKeysOnReset: t, filters: s, setFilters: i, readOnlyFilters: u, variant: m, apiBaseUrl: n, translations: d, filterVisibility: l, hasBusinessLimit: p, children: /* @__PURE__ */ r(c, {}) });
export {
  x as BusinessModal
};
